import { makeStyles } from '@mui/styles';

const getCellSize = (percentage: number) => {
  return `calc(100% * ${percentage / 100})`;
};

export const useTableRowStyles = makeStyles((theme) => ({
  rowContent: {
    display: 'flex',
    flex: '1 1 0',
    minWidth: 0,
  },
  
  cell: {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '16px 12px',
    minWidth: 0,
  },

  headerTextWrap: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    lineHeight: 1.2,
  },

  idCell: {
    minWidth: '72px',
    width: getCellSize(7),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  providerIdCell: {
    minWidth: '64px',
    width: getCellSize(7),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(9),
    },
  },

  riskCell: {
    minWidth: '80px',
    paddingLeft: '24px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(9),
    },
  },

  productTypeCell: {
    minWidth: '72px',
    width: getCellSize(7),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(9),
    },
  },

  defaultRateCell: {
    minWidth: '72px',
    width: getCellSize(7),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(8),
    },
  },

  nominalInterestCell: {
    minWidth: '72px',
    width: getCellSize(7),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(8),
    },
  },

  statusCell: {
    minWidth: '90px',
    width: getCellSize(9),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(12),
    },
  },

  durationCell: {
    minWidth: '72px',
    width: getCellSize(7),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(8),
    },
  },

  amountCell: {
    minWidth: '96px',
    width: getCellSize(9),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(11),
    },
  },

  dateCell: {
    minWidth: '84px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(9),
    },
  },

  priceCell: {
    paddingLeft: '16px',
    minWidth: '112px',
    width: getCellSize(15),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(16),
    },
  },

  inputCell: {
    display: 'flex',
    justifyContent: 'flex-end',
    maxWidth: 'calc(50px + 32px)',
    minWidth: 'calc(50px + 32px)',
    width: 'calc(50px + 32px)',
    minHeight: 'calc(34px + 36px)',
    flexShrink: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));
